// extracted by mini-css-extract-plugin
export default {"control":"control_control__hpfHe","button":"control_button__bEgQ6"};